import { initLoadInAnimationsAutoplay, removeLoadInAnimationsAutoplay } from '@pixelunion/load-in-animations';
import Rte from '../utils/Rte';

export default class StaticBlog {
  constructor(section) {
    this.el = section.el;
    this.dataBlogPostsGrid = this.el.querySelector('[data-blog-posts-grid]');
    this.rtes = [];

    this.el.querySelectorAll('[data-blog-article-content]').forEach(el => this.rtes.push(new Rte({ el })));

    this._initializeLoadInAnimations();
  }

  _initializeLoadInAnimations() {
    removeLoadInAnimationsAutoplay([this.dataBlogPostsGrid]);
    initLoadInAnimationsAutoplay({ threshold: 0 });
  }

  onSectionUnload() {
    this.rtes.forEach(rte => rte.unload());
  }
}
